import InsidePageLayout from "./InsidePageLayout";
export default InsidePageLayout;
